export default __webpack_public_path__ + "static/media/Ntorq125FI_Posterior.75cb6a97.webp";